/* ============
 * Campaigns Index
 * ============
 *
 * This page shows the list of campaigns.
 */

import { mapGetters, mapMutations } from 'vuex';
import campaignService from './../../../../services/campaign';
import SearchMixin from './../../../../mixins/search';
import DateMixin from './../../../../mixins/date';

export default {
  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      campaigns: 'paginatedCampaigns',
    }),
  },

  mounted() {
    this.setInnerSidebar([
      {
        title: this.$t('layouts.sidebar.newsletter'),
        options: [
          {
            title: this.$t('layouts.sidebar.all'),
            route: {
              name: 'campaigns.index',
            },
          },
        ],
        button: {
          title: this.$t('button.addCampaign'),
          route: {
            name: 'campaigns.create',
          },
        },
      },
      {
        title: this.$t('layouts.sidebar.subscriberList'),
        options: [
          {
            title: this.$t('layouts.sidebar.all'),
            route: {
              name: 'subscriberList.index',
            },
          },
        ],
        button: {
          title: this.$t('button.addSubscriberList'),
          route: {
            name: 'subscriberList.create',
          },
        },
      },
    ]);
    this.all(1, 15);
  },

  destroyed() {
    this.unsetInnerSidebar();
  },

  methods: {
    ...mapMutations({
      setInnerSidebar: 'SET_INNERSIDEBAR',
      unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
    }),

    /**
     * Fetches paginated campaigns.
     *
     * @param  {int} page The page number.
     * @param  {int} limit The number of items displayed on a page.
     */
    all(page, limit) {
      this.loading = true;
      campaignService.items(page, limit)
      .then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },

    /**
     * Delete specific Campaign.
     *
     * @param  {Object} campaign The Campaign object.
     */
    deleteCampaign(campaign) {
      this.$confirm(this.$t('static.campaigns.index.confirmDelete'), this.$t('static.campaigns.index.confirmDeleteTitle'), {
        confirmButtonText: this.$t('button.delete'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
      }).then(() => {
        campaignService.destroy(campaign.id)
        .catch(({ response }) => {
          const message = response.data.error.code === 40114 ? this.$t('static.campaigns.index.deleteHasClientsError') :
                          this.$t('static.campaigns.index.deleteError');
          this.$message({
            showClose: true,
            message,
            type: 'error',
          });
        });
      }).catch(() => {

      });
    },

    /**
     * Go to edit view for Campaign.
     *
     * @param  {Object} campaign The Campaign object.
     */
    edit(campaign) {
      this.$router.push({
        name: 'campaigns.edit',
        params: { id: campaign.id },
      });
    },
  },

  mixins: [
    SearchMixin,
    DateMixin,
  ],

  components: {
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VSelect: require('./../../../../components/form/select/select.vue'),
    VCard: require('./../../../../components/card/card.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/campaigns/index/index.js